const str2base64 = (str: string) => {
  return new Buffer(str).toString('base64')
}

// const str2base64 = str => {
//   return new Buffer(str).toString('base64')
// }

export default str2base64
